import { ConfirmProvider } from "material-ui-confirm";

export const ConfirmationProvider = ({ children }) => {
  return (
    <ConfirmProvider
      defaultOptions={{
        confirmationButtonProps: {
          autoFocus: true,
        },
      }}
    >
      {children}
    </ConfirmProvider>
  );
};
